export const wizardStepModel = Object.freeze({
  create: 'create',
  frequency: 'frequency',
  tiers: 'tiers',
  settings: 'settings',
  employees: 'employees',
  summary: 'summary',
});

export const wizardStepModelLinkedList = Object.freeze({
  [wizardStepModel.create]: {
    head: wizardStepModel.frequency,
    tail: undefined,
    name: wizardStepModel.create,
    step: 0,
  },
  [wizardStepModel.frequency]: {
    head: wizardStepModel.tiers,
    tail: wizardStepModel.create,
    name: wizardStepModel.frequency,
    step: 1,
  },
  [wizardStepModel.tiers]: {
    head: wizardStepModel.settings,
    tail: wizardStepModel.frequency,
    name: wizardStepModel.tiers,
    step: 2,
  },
  [wizardStepModel.settings]: {
    head: wizardStepModel.employees,
    tail: wizardStepModel.tiers,
    name: wizardStepModel.settings,
    step: 3,
  },
  [wizardStepModel.employees]: {
    head: wizardStepModel.summary,
    tail: wizardStepModel.settings,
    name: wizardStepModel.employees,
    step: 4,
  },
  [wizardStepModel.summary]: {
    head: undefined,
    tail: wizardStepModel.employees,
    name: wizardStepModel.summary,
    step: 5,
  },
});

/* eslint-disable max-len */
export const wizardSteps = [
  {
    id: '1',
    feature: wizardStepModel.create,
    header: {
      title: 'Create Policy',
      subTitle: `description here`,
    },
  },
  {
    id: '2',
    feature: wizardStepModel.frequency,
    header: {
      title: 'Accrual Frequency',
      subTitle: 'description here',
    },
  },
  {
    id: '3',
    feature: wizardStepModel.tiers,
    header: {
      title: 'Tiers',
      subTitle: 'description here',
    },
  },
  {
    id: '4',
    feature: wizardStepModel.settings,
    header: {
      title: 'Settings',
      subTitle: 'description here',
    },
  },
  {
    id: '5',
    feature: wizardStepModel.employees,
    header: {
      title: 'Employees',
      subTitle: 'description here',
    },
  },
  {
    id: '6',
    feature: wizardStepModel.summary,
    header: {
      title: 'Final Summary',
      subTitle: 'description here',
    },
  },
];
